import React from "react";
import styled from "styled-components";
import dices from "../Assets/dices.png";
import { Button } from "./Styled/Button";

function StartGame({toggle}) {
  return (
    <>
      <Container>
        <div><img src={dices} alt="" /></div>
        <div className="content">
          <h1>Dice Game </h1>
          <Button
           onClick={toggle}>Play Now</Button>
        </div>
      </Container>
    </>
  );
}

export default StartGame;

const Container = styled.div`
  max-width: 1180 px;
  display: flex;
  margin: 0 auto;
  height: 100vh;
  align-items: center;
  
  .content{
    h1{
        font-size: 89px;
        white-space: nowrap;
    }
  }

`;